module.exports = __webpack_public_path__ + "static/media/forward-icon.861741d4.svg";